"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("./formGroup.css");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const label_1 = require("@nbc-design/label");
const link_1 = require("@nbc-design/link");
const message_1 = require("@nbc-design/message");
const popover_1 = require("@nbc-design/popover");
const tooltip_1 = require("@nbc-design/tooltip");
/** A FormGroup wraps a form element with text to provide context and instructions to the user and handles validation. */
const FormGroup = ({ id, label, optionalText, tooltip, popover, link, children, description, introduction, validate, className, length, ...other }) => {
    const classes = (0, classnames_1.default)('dsc-formGroup', length && `is-${length}`, validate?.hasError && 'has-error', className);
    const renderLink = (link, className) => {
        const { ref, ...linkProps } = link;
        return ((0, jsx_runtime_1.jsx)(link_1.Link, { ...linkProps, ...(link.onClick && { type: 'button' }), className: className, underlined: true, children: link.children }));
    };
    const tooltipMarkup = () => {
        let tooltipReturnMarkup;
        if (tooltip) {
            const { className: tooltipClassName, ariaLabel, ...fwdProps } = tooltip;
            if (tooltip.content)
                tooltipReturnMarkup = ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { ...fwdProps, iIcon: { title: ariaLabel, size: 'medium' }, className: (0, classnames_1.default)('dsc-formGroup__tip', tooltipClassName) }));
        }
        return tooltipReturnMarkup;
    };
    const popoverMarkup = () => {
        let popoverReturnMarkup;
        if (popover) {
            const { className: popoverClassName, ariaLabel, ...fwdProps } = popover;
            if (popover.title && popover.content)
                popoverReturnMarkup = ((0, jsx_runtime_1.jsx)(popover_1.Popover, { ...fwdProps, iIcon: { title: ariaLabel }, className: (0, classnames_1.default)('dsc-formGroup__popover', popoverClassName) }));
        }
        return popoverReturnMarkup;
    };
    const labelMarkup = label && ((0, jsx_runtime_1.jsxs)(label_1.Label, { htmlFor: label.htmlFor, optionalText: optionalText, id: label.id, children: [label.text, tooltipMarkup(), popoverMarkup()] }));
    const linkMarkup = link ? renderLink(link, 'dsc-formGroup__actionLink') : null;
    const descriptionMarkup = description?.text && ((0, jsx_runtime_1.jsx)("span", { id: description.id || (id && `dsc-${id}__description`), className: "dsc-formGroup__description", "data-test": "description", children: description.text }));
    const introductionMarkup = introduction?.text && ((0, jsx_runtime_1.jsx)("span", { id: introduction.id || (id && `dsc-${id}__introduction`), className: "dsc-formGroup__introduction", "data-test": "introduction", children: introduction.text }));
    const errorMsgMarkup = validate?.hasError && validate?.errorMsg && ((0, jsx_runtime_1.jsx)(message_1.Message, { appearance: "error", id: validate.id || (id && `dsc-${id}__errorMsg`), children: validate.errorMsg }));
    return ((0, jsx_runtime_1.jsxs)("div", { ...other, id: id, className: classes, children: [(labelMarkup || linkMarkup) && ((0, jsx_runtime_1.jsxs)("div", { className: "dsc-formGroup__header", children: [labelMarkup, linkMarkup] })), introductionMarkup, children, descriptionMarkup, errorMsgMarkup] }));
};
exports.FormGroup = FormGroup;
exports.FormGroup.displayName = 'FormGroup';
//# sourceMappingURL=formGroup.js.map